// extracted by mini-css-extract-plugin
export default {"myDet":"mydet_myDet__6w+Ia","imageAndBlurb":"mydet_imageAndBlurb__yiJdg","imageAndButton":"mydet_imageAndButton__CPRZY","description":"mydet_description__fEZxi"};